import { synUtil } from "../../../../javascript/Utilities";
import { AjaxSolr } from "../../core/Core.js";
import { dateToStringShort, getGroupingOptions, stringToDateSolr, unescapeForSolr } from "../../core/synerisSolrBase.js";

(function ($) {
    AjaxSolr.CurrentSearchWidget = AjaxSolr.AbstractWidget.extend({
        constructor: function (attributes) {
            AjaxSolr.CurrentSearchWidget.__super__.constructor.apply(this, arguments);
            AjaxSolr.extend(this, {
                facets: []
            }, attributes);
            let self = this;
            self.groupingOptions = {};
            $.each(self.facets, function (idx, facet) {
                self.groupingOptions[facet.name] = getGroupingOptions(facet.name, facet.options);
            });
        },
        clearUI: function () {
            let $target = $(this.target);
            $target.html("");
            $target.addClass("baseWidget");
            $target.addClass("currentSearchWidget");
            // Remove clear-all button
            $target.parent().children("div.curSearchReset").remove();
        },
        beforeRequest: function () {
            this.clearUI();
            let $target = $(this.target);
            $target.append($("<img style='display:block;margin:auto' src='assets/images/loading_image.gif' class='synAjaxLoad_animation' />"));
            $target.children("div.footer.hasMore").remove();
        },
        afterRequest: function () {
            let $target = $(this.target);
            let self = this;
            let links = [];

            let createLink = function (allowReset, text, internalName) {
                let longText = text, shortText = text;

                if (internalName === "q")
                    if (text.length > 80) {
                        shortText = text.substring(0, 77) + "...";
                    }
                let cssClass = allowReset ? "curSearchItemReset" : "curSearchItemNoReset";
                let div = $("<div/>")
                    .addClass(cssClass);

                if (allowReset)
                    div.append($("<img src='assets/icons/close.png' />"));

                let tooltip = "";
                if (longText.length > shortText.length)
                    tooltip = "title='" + kendo.htmlEncode(longText) + "'";

                let outerDiv = $("<div>")
                    .append(div)
                    .append($("<strong><span " + tooltip + " class='curSearchItemText'>" + kendo.htmlEncode(unescapeForSolr(shortText)) + "</span></strong>"));

                if (allowReset) {
                    if (internalName !== "q")
                        return outerDiv.click(self.removeFacet(internalName));
                    else
                        return outerDiv.click(self.resetSearch());
                }
                else
                    return outerDiv;
            };

            let constraints = this.manager.getSearchConstraints();
            for (let i = 0; i < constraints.length; i++) {
                let searchLabelText = synUtil.Strings.getValue("searchlabel", "Search");
                let constr = constraints[i];
                if (constr[0] === "q")
                    links.push(createLink(!this.manager.requireSearchText, searchLabelText + ": " + constr[1], constr[0]).css("font-size", "larger"));
                else {
                    let text = "";
                    let internalField = constr[0];
                    constr[0] = self.manager.getSynerisDisplayFieldName(constr[0]);
                    let grouping = false;
                    $.each(self.groupingOptions[internalField], function (idx, option) {
                        if ("/" + option.regex.source + "/" === constr[1]) {
                            let facetTitle = synUtil.Strings.getValue(option.textKey);
                            if (facetTitle === option.textKey)
                                facetTitle = option.defaultText || facetTitle;

                            text = constr[0] + ": " + facetTitle;
                            grouping = true;
                            return false;
                        }
                    });
                    if (!grouping) {
                        if (this.manager.isDateWidget(internalField)) {
                            let dateParts = constr[1].split(" TO ");
                            dateParts[0] = dateParts[0].replace(/^\[/, "");
                            dateParts[1] = dateParts[1].replace(/]$/, "");

                            if (dateParts[0] !== "*") {
                                text += synUtil.Strings.getValue("rangefrom") + " " + dateToStringShort(stringToDateSolr(dateParts[0]));
                            }
                            if (dateParts[1] !== "*") {
                                if (text)
                                    text += " " + synUtil.Strings.getValue("rangeto").toLowerCase() + " ";
                                else
                                    text = synUtil.Strings.getValue("rangeto") + " ";

                                text += dateToStringShort(stringToDateSolr(dateParts[1]));
                            }

                            text = constr[0] + ": " + text;
                        }
                        else {
                            text = constr.join(": ");
                        }
                    }
                    links.push(createLink(true, text, internalField));
                }
            }

            let ul = $("<ul class='selection'></ul>").appendTo($target);
            for (let i = 0, l = links.length; i < l; i++) {
                ul.append($('<li class="curSearchItem"></li>').append(links[i]));
            }

            // add clear-all button only if there is more than one field-based constraint
            if (links.length > 1) {
                let removeAllSearchConstraints = synUtil.Strings.getValue("removeallsearchconstraints", "Remove all search constraints");
                !$target.parent().prepend(
                    $("<div class='curSearchReset'></div>")
                        .attr("title", removeAllSearchConstraints)
                        .click(function () {
                            // get all facet widgets and clear
                            let facets = self.manager.getWidgetsByType(AjaxSolr.AbstractFacetWidget);
                            $.each(facets, function (idx, widg) {
                                widg.clear();
                                widg.clearUI();
                            });

                            // clear result list
                            let resultLists = self.manager.getWidgetsByType(AjaxSolr.ResultWidget);
                            $.each(resultLists, function (idx, widg) {
                                widg.clearUI();
                            });

                            // clear fulltext search
                            self.manager.store.get('q').val("*:*");

                            //clear this current search
                            self.clearUI();

                            if (!self.manager.requireSearchText)
                                self.manager.doRequest();
                        }));
            }

            if (self.manager.response.hasMore) {
                let rows = self.manager.store.get("rows").val();
                let exceededFmt = synUtil.Strings.getValue("searchresultsexceededformat", "More than {0} results available. It is recommended to further refine the search.");
                let hasMoreDiv = $("<div class='footer hasMore'>" + kendo.format(exceededFmt, rows) + "</div>").appendTo($target);
                let iconUrl = synUtil.getWSUrl("Icon") + "resource=warning/16";
                hasMoreDiv.css({
                    "background-image": "url('" + iconUrl + "')",
                    "background-position": "5px 2px",
                    "background-repeat": "no-repeat",
                    "background-size": "16px auto"
                });
            }
            else if (self.manager.response.response) {
                let numFound = self.manager.response.response.numFound;
                let resultsFmt = synUtil.Strings.getValue("searchresultsformat", "{0} results available.");
                $("<div class='footer numFound'>" + kendo.format(resultsFmt, numFound) + "</div>").appendTo($target);
            }

            if (!links.length)
                $target.parent().css("display", "none");
            else
                $target.parent().css("display", "");

            $target.trigger("currentSearch", links.length);
        },
        cleanUp: function () {
            let tgt = $(this.target);
            // Remove AJAX animations from facet widgets
            tgt.children(".synAjaxLoad_animation").remove();
        },
        removeFacet: function (facet) {
            let self = this;
            return function () {
                if (self.manager.store.removeByValue('fq', new RegExp('^(\{!tag=[A-Za-z0-9_]+})*-?' + facet + ':'))) {
                    let q = self.manager.store.get('q').val();
                    if (!self.manager.requireSearchText || q && q !== '*:*')
                        self.doRequest();
                    else {
                        self.clearUI();
                    }
                }
                return false;
            };
        },
        resetSearch: function () {
            let self = this;
            return function () {
                self.manager.store.get('q').val("*:*");
                self.doRequest();
                return false;
            };
        }
    });

})(jQuery);
